import { render, staticRenderFns } from "./ReportParticular.vue?vue&type=template&id=f0c8211c"
import script from "./ReportParticular.vue?vue&type=script&lang=js"
export * from "./ReportParticular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports